import React, { useRef } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const imgQuery = graphql`
  query {
    file(relativePath: { eq: "white-wooden.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default () => {
  const data = useStaticQuery(imgQuery)
  return (
    <div className="relative">
      <div className="z-10 bg-gray-500 opacity-50 absolute w-full h-full inset-auto" />
      <Img
        className="h-128 bg-gray-900"
        fluid={data.file.childImageSharp.fluid}
      />
      <div className="absolute bottom-0 left-0 ml-10 mb-8 z-20">
        <h1 className="text-white text-5xl font-bold mb-6">
          Laissez-Vous
          <br />
          Inspirer.
        </h1>
        <p className="text-white text-xl font-bold ">
          &mdash; Découvrez notre gam.
        </p>
      </div>
    </div>
  )
}
